import { LayoutTypes } from "@/services/context/layout-helper";
import { useContextStore } from '@/store/context';
import { usePanierStore } from '@/store/panier';
import { useDatalayerStore } from '@/store/datalayer';
import { useCheckoutStore } from '@/store/checkout';
import { useGtm } from '@gtm-support/vue-gtm';

export const useCheckoutStepTracking = () => {
  const gtm = useGtm();
  const contextStore = useContextStore();
  const panierStore = usePanierStore();
  const datalayerStore = useDatalayerStore();
  const checkoutStore = useCheckoutStore();

  const { lignes, montantTotalTTC, abonnementDuration } = storeToRefs(panierStore);
  const { layout } = storeToRefs(contextStore);
  const { shippingMode: shippingMode, paymentMethod: paymentMethodDL } = storeToRefs(datalayerStore);
  const { checkout, dateRetrait, isCkdoSelected } = storeToRefs(checkoutStore)

  const trackCheckOutStep = (labelGA, step) => {
    const products = [];
    let nbArticles = 0;
    for (let i = 0; i < lignes.value.length; i++) {
      const quantite = parseInt(lignes.value[i].quantite);
      nbArticles += quantite;
      const product = {
        id: lignes.value[i].id,
        name: lignes.value[i].designation,
        price: lignes.value[i].prix.toFixed(2),
        quantity: quantite,
        metric4: lignes.value[i].prix_ht,
        metric3: lignes.value[i].taux_tva,
        dimension12: lignes.value[i].nombre_images,
        dimension11: "",
        category: lignes.value[i].category_path,
        dimension10: "",
        dimension13: "",
        metric5: ""
      }
      if (lignes.value[i].discount_amount) {
        product.metric5 = lignes.value[i].discount_amount
      }
      if (lignes.value[i].pft === 1 && lignes.value[i].pft_conf) {
        product.metric5 = lignes.value[i].pft_conf.PLAGE[lignes.value[i].indexPoids].REDUC
      }
      if (lignes.value[i].avis_moyenne && lignes.value[i].nombres_avis) {
        product.dimension13 = lignes.value[i].nombres_avis
        product.dimension10 = lignes.value[i].avis_moyenne
      }
      if (lignes.value[i].taille && lignes.value[i].coloris) {
        product.variant = `${lignes.value[i].taille} /${lignes.value[i].coloris}`
      }
      if (lignes.value[i].marque) {
        product.brand = lignes.value[i].marque;
      }

      products.push(product)
    }
    const pushObject = {
      event: trackingCodes.EVENTS.checkout,
      categoryGA: trackingCodes.CATEGORYGA.ecommerce,
      actionGA: trackingCodes.ACTIONGA.checkoutStep,
      labelGA,
      nonInteraction: true,
      panierMontantTotalTTC: montantTotalTTC.value,
      panierNombreArticles: nbArticles,
      abonnementAuPanier: abonnementDuration.value ? abonnementDuration.value + "mois" : "aucun",
      ecommerce: {
        checkout: {
          actionField: { step }
        }
      }
    }
    if (step === 1) { pushObject.ecommerce.checkout.products = products }
    if (step === 3) { pushObject.ecommerce.checkout.actionField.option = shippingMode.value }
    if (step === 4) {
      const creneau = dateRetrait.value !== null ? dateRetrait.value.date_du_jour : ""
      let today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      today = `${yyyy}-${mm}-${dd}`;
      const deltaLivraison = creneau > today
        ? trackingCodes.SHIPPINGDELTA.jplus
        : trackingCodes.SHIPPINGDELTA.jplus
      pushObject.ecommerce.checkout.actionField.option = deltaLivraison;
      pushObject.deltaLivraison = deltaLivraison;
    }
    if (step === 5) { 
      pushObject.ecommerce.checkout.actionField.option = paymentMethodDL.value 
      if(checkout?.value?.attributes?.carteCadeau) {
        pushObject.action = 'utilisation carte Cora'
        pushObject.paiement_carte_cadeau = checkout.value?.attributes?.carteCadeau.montant >= parseFloat(checkout.value?.attributes?.panier.data?.attributes?.montant_total_ttc) ? 'total' : 'partiel'
        pushObject.montant_carte = checkout.value?.attributes?.carteCadeau?.montant
      }
    }
    pushObject.sitetype = layout.value === LayoutTypes.default ? 'd' : 'm'
    try {
      gtm.trackEvent(pushObject)
    } catch { }

  }

  return { trackCheckOutStep }
}
